module.exports = "/_next/static/images/ba758b5beefa05c49accaf7db9ee2e5d-hero-md.jpg.webp";